import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';
import { ImprovementProposal } from '../Model/ImprovementProposal';

export async function createImprovementProposal(data) {
  const response = await getAPIResponse('/v1/improvement-proposal', data, 'POST');
  if (response === null) return null;
  try {
    return ImprovementProposal.createFromResponseData(response);
  } catch (e) {
    return null;
  }
}
